import StackedUserAvatars from "components/images/StackedUserAvatars/StackedUserAvatars";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store/hooks";
import { updateShowThankYouScreen } from "store/ui/thankYouScreen/thankYouScreen.slice";
import { Donor } from "types";
import {
  BottomCircle,
  ThankYouAmount,
  ThankYouAmountSmall,
  ThankYouAmountWrapper,
  ThankYouBackground,
  ThankYouBody,
  ThankYouBodyLeft,
  ThankYouBodyRight,
  ThankYouBodyRow,
  ThankYouBodyText,
  ThankYouCloseIcon,
  ThankYouContainer,
  ThankYouFooter,
  ThankYouFootersdw,
  ThankYouHeader,
  ThankYouIcon,
  ThankYouIconCircle,
  ThankYouIconOutline,
  ThankYouIconWrapper,
  ThankYouSubHead,
  ThankYouTitle,
  TopCircle,
} from "./ThankYouModal.styles";

function ThankYouModal() {
  const dispatch = useDispatch();
  const donorsList: Donor[] | any = useAppSelector(state => state.donorsList);
  const dollarAmount: string | undefined = useAppSelector(state => state.showThankYou.donationAmount);
  const eventTitle: string | undefined = useAppSelector(state => state.showThankYou.eventTitle);

  const getDonors = () => {
    let donors: string[] = [];
    let i = 0;
    while (i < donorsList.length) {
      if (donorsList[i].anon !== 0 && donorsList[i].status === "success" && !donors.includes(donorsList[i].user.socialAvatarUrl)) {
        donors.push(donorsList[i].user.socialAvatarUrl);
      }

      i++;
    }

    return donors;
  }

  const donorImages = getDonors();

  return (
    <>
      <ThankYouBackground onClick={() => dispatch(updateShowThankYouScreen(false))} />

      <ThankYouContainer>
        <ThankYouHeader>
          <ThankYouCloseIcon className="fa-solid fa-xmark" onClick={() => dispatch(updateShowThankYouScreen(false))} />
          <ThankYouIconWrapper>
            <ThankYouIconOutline>
              <ThankYouIcon className="fa-solid fa-check" />
              <TopCircle />
              <ThankYouIconCircle />
              <BottomCircle />
            </ThankYouIconOutline>
          </ThankYouIconWrapper>
          <ThankYouTitle> Thank you for your donation! </ThankYouTitle>
        </ThankYouHeader>

        <ThankYouBody>
          <ThankYouBodyText>
            Congratulations! You have successfully donated to the "{eventTitle}" event.
            Press one of the icons below to share your contribution with your network or
            press the "x" to close. (You may now close the browser if on mobile)
          </ThankYouBodyText>
          <ThankYouBodyRow>
            <ThankYouBodyLeft>
              <ThankYouSubHead>You successfully donated:</ThankYouSubHead>
              <ThankYouAmountWrapper>
                <ThankYouAmountSmall>$</ThankYouAmountSmall>
                <ThankYouAmount>{dollarAmount}</ThankYouAmount>
              </ThankYouAmountWrapper>
            </ThankYouBodyLeft>

            <ThankYouBodyRight>
              <ThankYouSubHead>{donorImages.length} People have donated</ThankYouSubHead>
              <StackedUserAvatars images={donorImages} />
            </ThankYouBodyRight>
          </ThankYouBodyRow>
        </ThankYouBody>

        <ThankYouFooter>
          <ThankYouFootersdw>
            <i className="fa-brands fa-instagram" />
            <i className="fa-brands fa-facebook" />
            <i className="fa-brands fa-twitter" />
            <i className="fa-brands fa-google" />
          </ThankYouFootersdw>
        </ThankYouFooter>
      </ThankYouContainer>
    </>
  )
}

export default ThankYouModal;
